module.exports = __webpack_public_path__ + "static/thumbnail-a8a4c52cebc236c3996907dfeef46330.png";